module.exports = __webpack_public_path__ + "static/media/1.9343f6cd.jpeg";